export const config = {
  API: {
    PORT_DB: process.env.REACT_APP_PORT_DB,
    BASE_URL_UPLOAD: "/api/extdata",
    BASE_URL_PLAN_SCENARIO: "/api/scenarios",
  },
};

export const keyIntegration = {
  keyEncrypt: process.env.REACT_APP_KEYENCRYPT,
};

// Backend API keys are added server-side by the nginx proxy in this container
// (nginx/default.conf.template), which first checks the user's session token
// with access control. The browser only sends that token.
export const apiAuthHeaders = () => ({
  "x-access-token": JSON.parse(sessionStorage.getItem("userData") || "{}")?.token ?? "",
});
